import React from "react";
import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import "./ClearFiltersButton.css";

export interface ClearFiltersButtonProps {
  /** Called when button is clicked */
  onClick: () => void;
  /** Whether the button should be visible */
  visible: boolean;
  /** Button label */
  label?: string;
  /** Additional CSS class name */
  className?: string;
}

/**
 * Clear filters button that only renders when visible.
 */
export const ClearFiltersButton: React.FC<ClearFiltersButtonProps> = ({
  onClick,
  visible,
  label,
  className = "",
}) => {
  const { t } = useTranslation(["common"]);
  const displayLabel = label ?? t("common:actions.clearFilters");

  if (!visible) {
    return null;
  }

  return (
    <button
      type="button"
      className={`btn-clear-filters ${className}`}
      onClick={onClick}
      aria-label={t("common:actions.clearAllFilters")}
    >
      <X size={14} aria-hidden="true" />
      {displayLabel}
    </button>
  );
};

export default ClearFiltersButton;
